var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Organization from '../Organization';
var OrganizationStub = /** @class */ (function (_super) {
    __extends(OrganizationStub, _super);
    function OrganizationStub(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.id, id = _c === void 0 ? '123' : _c, _d = _b.name, name = _d === void 0 ? 'Kaizen Platform' : _d;
        return _super.call(this, { id: id, name: name }) || this;
    }
    return OrganizationStub;
}(Organization));
export default OrganizationStub;
